import app from './app';
import ui from './ui';
import cms from './cms';
import home from './home';
import about from './about';
import services from './services';
import contact from './contact';
import fleet from './fleet';
import request from './request';

export default {
  app,
  ui,
  cms,
  home,
  about,
  services,
  contact,
  fleet,
  request,
};
